var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import clsx from "clsx";
import { createStyles, makeStyles } from "@material-ui/core";
var useStyles = makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return createStyles({
        root: (_b = {
                width: "100%",
                maxWidth: 1280,
                boxSizing: "border-box",
                marginLeft: "auto",
                marginRight: "auto",
                padding: "0 16px"
            },
            _b[breakpoints.up("lg")] = {
                padding: "0 72px",
            },
            _b),
    });
});
var Container = function (props) {
    var styles = useStyles();
    var className = props.className, otherProps = __rest(props, ["className"]);
    return React.createElement("div", __assign({ className: clsx(styles.root, className) }, otherProps));
};
export default Container;
